export default __webpack_public_path__ + "static/media/image-cover.41a73b0a.jpg";